import { useStaticQuery, graphql } from "gatsby";

export const GetTestimonialData = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpTestimonial {
        nodes {
          clientName
          clientTestimonial
          altText
          clientImage {
            guid
          }
          clientDesignation
        }
      }
    }
  `);
  return data.allWpTestimonial.nodes;
};
